import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';



const BaseUrl = process.env.REACT_APP_API_URL;



// Async thunk to fetch payroll dropdown data
export const fetchPayrollDropdown = createAsyncThunk(
    'payroll/fetchPayrollDropdown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/PayRoll/EmtDetailsMain`);
            return response.data;
        } catch (error) {
            toast.error("Failed to fetch payroll dropdown");
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


// Async thunk to fetch payroll data by Member ID
export const fetchPayrollDataByMemberId = createAsyncThunk(
    'payroll/fetchPayrollDataByMemberId',
    async (memberId, { rejectWithValue }) => {

        try {
            const response = await axios.get(`${BaseUrl}/PayRoll/InOutTime/${memberId}`);
            return response.data;
        } catch (error) {
            toast.error("Failed to fetch Member Data");
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


// Async thunk to fetch date-wise In/Out details
export const fetchDatewisePayrollData = createAsyncThunk(
    'payroll/fetchDatewisePayrollData',
    async ({ memberId, selectedDate }, { rejectWithValue }) => {
        try {
            const dateObj = new Date(selectedDate);
            const payload = {
                Date: dateObj.getDate(),
                Month: dateObj.getMonth() + 1,
                Year: dateObj.getFullYear(),
            };

            const response = await axios.post(`${BaseUrl}/PayRoll/InOutTimeDetails/${memberId}`, payload);
            return response.data;
        } catch (error) {
            toast.error("Failed to fetch date-wise details");
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchPayrollFilterByDateRange = createAsyncThunk(
    'payroll/fetchPayrollFilterByDateRange',
    async ({ memberId, fromDate, toDate }, { rejectWithValue }) => {
        try {
            const payload = {
                memberId: memberId?.value, // assuming Autocomplete format
                from: fromDate,
                to: toDate,
            };

            const response = await axios.post(`${BaseUrl}/PayRoll/InOutTimeDetailsfilter/${memberId?.value}`, payload);
            return response.data;
        } catch (error) {
            toast.error("Failed to fetch filtered data");
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const fetchAllAttendanceByDateRange = createAsyncThunk(
    'payroll/fetchAllAttendanceByDateRange',
    async ({ fromDate, toDate }, { rejectWithValue }) => {
        try {
            const payload = {
                from: fromDate,
                to: toDate,
            };

            const response = await axios.post(`${BaseUrl}/PayRoll/AllInOutTimeDetailsfilter`, payload);
            return response.data;
        } catch (error) {
            toast.error("Failed to fetch workforce attendance data");
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


const Payroll = createSlice({
    name: 'payroll',
    initialState: {
        payrollDropdownData: [],
        payrollLoading: false,
        payrollError: null,

        MemberData: null,
        memberDataLoading: false,
        memberDataError: null,

        DatewiseData: null,
        datewiseLoading: false,
        datewiseError: null,

        FilteredData: null,
        filterLoading: false,
        filterError: null,

        AllAttendanceData: null,
        allAttendanceLoading: false,
        allAttendanceError: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(fetchPayrollDropdown.pending, (state) => {
                state.payrollLoading = true;
                state.payrollError = null;
            })
            .addCase(fetchPayrollDropdown.fulfilled, (state, action) => {
                state.payrollLoading = false;
                state.payrollDropdownData = action.payload;
            })
            .addCase(fetchPayrollDropdown.rejected, (state, action) => {
                state.payrollLoading = false;
                state.payrollError = action.payload;
            })


            .addCase(fetchPayrollDataByMemberId.pending, (state) => {
                state.memberDataLoading = true;
                state.memberDataError = null;
            })
            .addCase(fetchPayrollDataByMemberId.fulfilled, (state, action) => {
                state.memberDataLoading = false;
                state.MemberData = action.payload;
            })
            .addCase(fetchPayrollDataByMemberId.rejected, (state, action) => {
                state.memberDataLoading = false;
                state.memberDataError = action.payload;
            })

            .addCase(fetchDatewisePayrollData.pending, (state) => {
                state.datewiseLoading = true;
                state.datewiseError = null;
            })
            .addCase(fetchDatewisePayrollData.fulfilled, (state, action) => {
                state.datewiseLoading = false;
                state.DatewiseData = action.payload;
            })
            .addCase(fetchDatewisePayrollData.rejected, (state, action) => {
                state.datewiseLoading = false;
                state.datewiseError = action.payload;
            })

            .addCase(fetchPayrollFilterByDateRange.pending, (state) => {
                state.filterLoading = true;
                state.filterError = null;
            })
            .addCase(fetchPayrollFilterByDateRange.fulfilled, (state, action) => {
                state.filterLoading = false;
                state.FilteredData = action.payload;
            })
            .addCase(fetchPayrollFilterByDateRange.rejected, (state, action) => {
                state.filterLoading = false;
                state.filterError = action.payload;
            })

            .addCase(fetchAllAttendanceByDateRange.pending, (state) => {
                state.allAttendanceLoading = true;
                state.allAttendanceError = null;
            })
            .addCase(fetchAllAttendanceByDateRange.fulfilled, (state, action) => {
                state.allAttendanceLoading = false;
                state.AllAttendanceData = action.payload;
            })
            .addCase(fetchAllAttendanceByDateRange.rejected, (state, action) => {
                state.allAttendanceLoading = false;
                state.allAttendanceError = action.payload;
            })
    },
});

export default Payroll.reducer;
